import React, { useState, useEffect } from 'react'
import Layout from '../../component/layout'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { getItem } from '../../../../utils/localStorage';
import { toastify } from '../../../../utils/toast';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { ReceptionistRegistrationURL } from '../../../../utils/urls';

const RegisterReceptionist = () => {
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email,setEmail] = useState('')

    const handleReceptionSubmit = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const receptionData = {
                firstName,
                lastName,
                phoneNumber,
                email
            };

            if (!receptionData.firstName) throw new Error('First name is required.');
            if (!receptionData.phoneNumber) throw new Error('Phone number is required.');
            if (!receptionData.lastName) throw new Error('Last name is required.');
            if (!receptionData.email) throw new Error('Email name is required.');

            const response = await makeRequest2(ReceptionistRegistrationURL + '/' + facilityId, 'POST', receptionData);

            if (response.success) {
                toastify('Receptionist added successfully', 'success');
                setFirstName('');
                setLastName('');
                setPhoneNumber('');
                navigate('/facility/visitor_access_management/reception')
            }
            else {
                throw new Error(response.error);
            }
        }
        catch (err) {
           
           toastify(err.message, 'error')
        }
    }

    const handleReceptionClear = () => {
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
    };

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Receptionist Registration</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">

                            <div className="card">
                                <div className="card-header">
                                    <Link to={"#"} onClick={() => navigate(-1)}><span><i className="ti ti-arrow-narrow-left"></i> Back</span></Link>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-header">
                                    <h5>Receptionist Registration</h5>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12">

                                        <div className="card-body">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="card">

                                                        <div className="card-body">
                                                            <div className='container'>
                                                                <div className='row'>
                                                                    <div className="col-sm-6">
                                                                        <div className="mb-3">
                                                                            <label className="form-label">First Name<span style={{ color: 'red' }}>*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="mb-3 form-control"
                                                                                value={firstName}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    setFirstName(value)
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm-6">
                                                                        <div className="mb-3">
                                                                            <label className="form-label">Last Name<span style={{ color: 'red' }}>*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="mb-3 form-control"
                                                                                value={lastName}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    setLastName(value)
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm-6">
                                                                        <div className="mb-3">
                                                                            <label className="form-label">Mobile Number<span style={{ color: 'red' }}>*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                className="mb-3 form-control"
                                                                                placeholder="e.g. +254 712 345 678"
                                                                                value={phoneNumber}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    setPhoneNumber(value)
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <div className="mb-3">
                                                                            <label className="form-label">Email</label>
                                                                            <input
                                                                                type="email"
                                                                                className="mb-3 form-control"
                                                                                placeholder=""
                                                                                value={email}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    setEmail(value)
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="text-end">
                                                                <button type="button" className="btn btn-outline-secondary" onClick={handleReceptionClear}>Clear</button>
                                                                &nbsp;
                                                                <button type="button" className="btn btn-primary" onClick={handleReceptionSubmit}>Submit</button>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout >
    )
}

export default RegisterReceptionist;